import { PropsWithChildren } from 'react'

import { AssignManagerForm } from './AssignForm'
import { AssignManagerProps } from './interface'
import { AssignManagerStoreProvider } from './Store'

export const AssignManager = ({
  children,
  ...rest
}: PropsWithChildren<AssignManagerProps>) => {
  return (
    <AssignManagerStoreProvider {...rest}>
      {children}
      <AssignManagerForm />
    </AssignManagerStoreProvider>
  )
}
